import React from "react";

const ProjectSummery = ({ task }) => {
  return (
    <div className="card z-depth-0 project-summary">
      <div className="card-content grey-text text-darken-3">
        <span className="card-title  ">{task.title}</span>
        <p>{task.firstName + " " + task.lastName}</p>
        <p className="red-text">{task.date.toDate().toDateString()} </p>
      </div>
    </div>
  );
};

export default ProjectSummery;
